<template>
    <div class="tw-block-parent" :style="reply? 'display: flex; margin-bottom: 0': null">
        <div class="timeline-TweetList-tweet" :style="reply? 'width: 90%; margin-left: auto; margin-bottom: 0.5em;': null">
            <div class="timeline-Tweet"  :style="reply? 'background-color: #eee': null">
                <div class="timeline-Tweet-author">
                    <div class="TweetAuthor">
                        <a class="TweetAuthor-link"></a>
                        <span class="TweetAuthor-avatar">
                            <div class="Avatar" :style="avatar"></div>
                        </span>
                        <span class="TweetAuthor-name">{{authorName}}</span>
                        <span class="Icon Icon--verified" v-if="verified"></span>
                        <span class="TweetAuthor-screenName">@{{authorHandle}}</span>
                        <span class="TweetAuthor-dot"><i class="fas fa-circle"></i></span>
                        <span class="TweetAuthor-timePublished">{{time_since_publish}}</span>
                    </div>
                </div>
                <div class="timeline-Tweet-text" :id="'tweet-text-' + post_id"></div>
                <div v-if="edit" class="timeline-Tweet-metadata button" :style="queued ? 'right: 35px' : ''" @click="removeTweet">
                    <i class="fas fa-trash-alt" style="color: #ed5338" />
                </div>
                <ul class="timeline-Tweet-actions" v-if="!queued">
                    <li class="timeline-Tweet-action" @click="replyTweet"><i class="fas fa-comment-alt action-comment" /></li>
                    <li v-if="!parent_post_id" class="timeline-Tweet-comments">{{replies.length}} svar</li>
                    <li v-if="!parent_post_id && replies.length > 0" class="timeline-Tweet-comments button" @click="hideReplies">
                        <i v-show="!replies_hidden" class="fas fa-chevron-down" style="margin:0"/>
                        <i v-show="replies_hidden" class="fas fa-chevron-up" style="margin:0"/>
                    </li>
                </ul>
            </div>
        </div>
        <div class="repliesContainer" v-if="replies.length > 0 && !reply && !replies_hidden">
            <Tweet v-for="tweet in replies" :key="tweet.post_id" :publishTime="tweet.publish_time_ts"
                :authorName="tweet.account_name" :authorHandle="tweet.account_handle" :parent_post_id="tweet.parent_post_id"
                :verified="tweet.verified" :imageUrl="tweet.image_url" :text="tweet.text" 
                :sender="tweet.sender" :edit="edit" :post_id="tweet.post_id" :reply="true" 
                @replyTweet="replyTweet" @removeTweet="removeTweet" />
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/da';
import Tweet from './Tweet';
import { mapGetters } from 'vuex';
dayjs.locale('da')

export default {
    name: 'Tweet',
    components: {
        Tweet
    },
    props: {
        post_id: Number,
        parent_post_id: Number,
        authorName: String,
        authorHandle: String,
        verified: Boolean,
        text: String,
        sender: String,
        imageUrl: String,
        publishTime: Number,
        edit: Boolean,
        queued: Boolean,
        reply: Boolean,
        pgroup_id: Number
    },
    data(){
        return {
            time_since_publish: '',
            replies_hidden: false
        }
    },
    watch: {
        text() {
            let text_el = document.getElementById('tweet-text-' + this.post_id);
            text_el.innerHTML = this.text_html;
        }
    },
    computed: {
        ...mapGetters([
            'getPubPosts'
        ]),
        avatar() {return this.imageUrl ? 'background-image: url(' + this.imageUrl + ')' : ''},
        replies() {return this.getPubPosts.filter(p => p.type == 'twitter' && p.parent_post_id == this.post_id).reverse()},
        text_html() {
            // Highlight mentions (@)
            const matches = [...this.text.matchAll(/(@[^\s]*)/g)]
            if (matches.length == 0) return this.text
            let inner_html = ""
            let last_index = 0
            for (let match of matches) {
                inner_html += this.text.substring(last_index, match.index) + "<span style='color: #1B95E0'>" + this.text.substring(match.index, match.index + match[0].length) + "</span>"
                last_index += this.text.substring(last_index, match.index).length + match[0].length
            }
            inner_html += this.text.substring(last_index, this.text.length)
            return inner_html
        }
    },
    methods: {
        hideReplies() {
            this.replies_hidden = !this.replies_hidden
        },
        removeTweet: function(post_id=null) {
            isNaN(post_id)? post_id = null: null
            this.$emit('removePost', post_id? post_id: this.post_id)
        },
        sendTweet() {
            this.$emit('sendTweet', this.post_id)
        },
        getTimePublished() {
            const difference = dayjs().from(dayjs.unix(this.publishTime), true)
            this.time_since_publish = difference
        },
        replyTweet(post_id=null, author_handle=null) {
            post_id && author_handle ?
            this.$emit('replyTweet', this.post_id, author_handle) :
            this.$emit('replyTweet', this.post_id, this.authorHandle)
        }
    },
    mounted() {
        if (this.publishTime) {
            dayjs.extend(relativeTime)
            this.getTimePublished()
            setInterval(this.getTimePublished, 44000)
        }
        const text_el = document.getElementById('tweet-text-' + this.post_id);
        text_el.innerHTML = this.text_html;
    }
}
</script>

<style>

.repliesContainer {
    margin-top: 0.5em;
}

.replyIndicator {
    width: 1px;
    margin-left: auto;
    background-color: #8899A6;
}

</style>